import { httpApi } from '@app/api/http.api'

export type CreateFirmPayload = {
  name: string
  nip: string
  regon: string
  description: string
  addresses: FirmAddressResponse[]
  phones: FirmPhoneResponse[]
  devices: string[] | []
}

export type UpdateFirmPayload = {
  id: string
  data: CreateFirmPayload & {
    usersToUpdate?: { id: string; devices: string[] }[]
  }
}

export type FirmsResponse = {
  id: string
  name: string
  description?: string
  nip?: string
  regon?: string
  addresses?: FirmAddressResponse[]
  phones?: FirmPhoneResponse[]
  devices?: string[]
}

export type PartOfDataAllFirmsResponse = {
  id: string
  name: string
  devices: string[]
}

export type FirmDetailsResponse = {
  addresses: FirmAddressResponse[]
  devices: string[]
}
export type FirmDevicesResponse = {
  id: string
  devices: string[]
}

export type FirmCreateData = {
  id: string
  addresses: { id: string }[]
  phones: { id: string }[]
}

type FirmAddressResponse = {
  id?: string
  country?: string
  region?: string
  city: string
  street: string
  house?: string
  room?: string
  zipCode?: string
  longitude?: string
  latitude?: string
}

type FirmPhoneResponse = {
  id?: string
  phone: string
  description?: string | null
  type?: string
  status?: string
  createdAt?: string | Date
  updatedAt?: string | Date
}

const FIRMS = 'firms'

export const getAllFirmsTable = (): Promise<FirmsResponse[]> =>
  httpApi.get<FirmsResponse[]>(`${FIRMS}/all-table`).then(({ data }) => data)

export const updateFirm = ({ id, data }: UpdateFirmPayload): Promise<void> =>
  httpApi.put<void>(`${FIRMS}/update-firm/${id}`, data).then(() => undefined)

export const getFirmDetails = (id: string): Promise<FirmDetailsResponse> =>
  httpApi.get<FirmDetailsResponse>(`${FIRMS}/details/${id}`).then(({ data }) => data)

export const createFirm = (createFirmPayload: CreateFirmPayload): Promise<FirmCreateData> =>
  httpApi.post<FirmCreateData>(`${FIRMS}/create-firm`, createFirmPayload).then(({ data }) => data)

export const getDevicesForFirms = (firmIds: string[]): Promise<FirmDevicesResponse[]> =>
  httpApi.post<FirmDevicesResponse[]>(`${FIRMS}/devices-for-firms`, { firmIds }).then(({ data }) => data)

export const getPartOfDataAllFirms = (): Promise<PartOfDataAllFirmsResponse[]> =>
  httpApi.get<PartOfDataAllFirmsResponse[]>(`${FIRMS}/part-firms-data`).then(({ data }) => data)

export const deleteFirm = (id: string): Promise<string> =>
  httpApi.delete<string>(`${FIRMS}/${id}`).then(({ data }) => data)
